import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Card } from 'antd';
import { capitalize } from 'lodash';
import '../styles/annotationeditScreen.less';

type DetectionData = {
  title?: string | null;
  childType?: string | null;
  confidence?: number | null;
  childID?: string | null | undefined;
  parentID?: string | null;
  parentType?: string | null;
};

type DetectionCardProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filteredDetections?: any;
  item: DetectionData;
  onDelete?: () => void;
  onEdit?: () => void;
  selectedId?: string | number | null;
  handleBboxClick: (id: string | number) => void;
};

const DetectionCard = ({
  item,
  onDelete,
  onEdit,
  selectedId,
  handleBboxClick,
  filteredDetections,
}: DetectionCardProps) => {
  const getDisplayTitle = () => {
    const itemTitle = item?.title || '';
    const parentID = item?.parentID;

    if (!parentID || !filteredDetections) {
      return capitalize(itemTitle);
    }

    const parentItem = filteredDetections.find(
      (detection: DetectionData) => detection.childID === parentID,
    );

    if (parentItem && parentItem.title) {
      return `${capitalize(itemTitle)} in ${capitalize(parentItem.title)}`;
    }

    return capitalize(itemTitle);
  };

  return (
    <div className="guideline">
      <div className="guidelines-container">
        <Card
          onClick={() => {
            handleBboxClick(item?.childID as string);
          }}
          className={`annotation-info-card ${selectedId === item?.childID ? 'selected-card' : ''}`}
          title={getDisplayTitle()}
          actions={[
            <>
              <div className="actions-btn-div">
                <Button
                  icon={<EditOutlined />}
                  className="action-btn"
                  type="link"
                  onClick={onEdit}
                >
                  Edit
                </Button>

                <Button
                  type="link"
                  icon={<DeleteOutlined />}
                  onClick={onDelete}
                  className="action-btn"
                >
                  Delete
                </Button>
              </div>
            </>,
          ]}
        >
          <div>
            <strong>Type:</strong> {capitalize(item?.childType || '')}
          </div>

          <div>
            <strong>Confidence: </strong>
            {item?.confidence == null ? 'N/A' : item.confidence}%
          </div>
        </Card>
      </div>
    </div>
  );
};

export default DetectionCard;
